export default {
      id: "icon-iOS-usage",
      viewBox: "0 0 16 16",
      url: "/" + "assets/sprite.svg#icon-iOS",
      toString: function () {
        return this.url;
      }
    }